module.exports = __webpack_public_path__ + "8056d387caf383199ae85c5b26799f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/R1P_Logo_Grey.png
// module id = 48
// module chunks = 0